import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { ConfirmPrompt } from './ui/confirm_prompt.js';

export { ConfirmPrompt } from './ui/confirm_prompt.js';

/** Entrada de catálogo do `confirm_prompt` — slot `chat`, interativo. */
export const confirmPromptEntry: GenUiEntry<Extract<ChatUi, { kind: 'confirm_prompt' }>> = {
  kind: 'confirm_prompt',
  slot: 'chat',
  policy: {
    // Cada emissão carrega um challenge NOVO com o mesmo id (o evento pede «Incluir no convite» ou
    // «Salvar alterações» de novo): reconciliar por id ancoraria as respostas na primeira linha,
    // lá em cima na conversa, e o turno atual ficaria só com a fala.
    reconcileById: false,
  },
  render: (props) => <ConfirmPrompt {...props} />,
};
